export default "__VITE_ASSET__D$s4M6Zr__"